import Vue from 'vue';
import Hotjar from 'vue-hotjar';

Vue.use(Hotjar, {
  id: '2444081',
  isProduction: process.env.NODE_ENV === 'production',
});
